export const colors = {
    base: '#08424D',
    copy: '#08424D',
    primary: '#00A9C5',
    highlight: '#155965',
    input: '#155965',
}